import React, { forwardRef } from 'react';
import { Input } from 'antd';
import styled from 'styled-components';
const InputWrapper = styled.div `
  padding: 0.3rem;
`;
// Workaround for inputs overflowing parent dimensions (ignoring or possibly overriding
// box-sizing: border-box?)
export const BoundedSearch = forwardRef((props, ref) => (React.createElement(InputWrapper, null,
    React.createElement(Input.Search, { ref: ref, ...props }))));
